var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.515,
    height: 17.515,
    viewBox: "0 0 21.515 17.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-1828.243 -1484.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 2.084,
    height: 7.497,
    rx: 0.5,
    transform: "translate(1844.862 1491.958) rotate(90)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1837.773,1489.68v6.64a.5.5,0,0,1-.842.365l-3.548-3.32a.5.5,0,0,1,0-.73l3.548-3.32A.5.5,0,0,1,1837.773,1489.68Z",
    fill: "#18c99d",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 20.224,
    height: 16.224,
    rx: 2,
    transform: "translate(1828.888 1484.888)",
    fill: "none",
    stroke: "#18c99d",
    strokeWidth: 1.291
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowSquare);
export default __webpack_public_path__ + "static/media/icon-arrow-square.be1a97976eff809d7eadff5de9f1b33c.svg";
export { ForwardRef as ReactComponent };